module.exports = __webpack_public_path__ + "media/fonts/OFN-v2-86be2c303cee6af5d61bd88dd91f639d.eot";